import { useCallback } from 'react'

import LeadService from 'modules/lead/service'
import ChatService from 'modules/chat/service'
import { ERROR } from 'common/constants'
import { EMPTY_POST_LEAD_RESPONSE } from 'modules/lead/constants'
import { usePostLeadContext } from '../context'
import { PostLeadResponse } from '../types'

const usePostLead = () => {
  const { setIsLoading, setResponse, setHasError } = usePostLeadContext()

  const postLead = useCallback(async (
    {
      schedule,
      email,
      name,
      userPlatformId,
      accepted
    }: { schedule: string, email: string, name: string, userPlatformId?: number, accepted?: boolean }
  ) => {
    let response: PostLeadResponse | undefined = void 0

    if (!schedule || !email || !name) {
      return response
    }

    try {
      setIsLoading(true)

      const contactId = await ChatService.getContactId()

      response = await LeadService.postLead({
        schedule,
        contactId,
        userId: userPlatformId || void 0,
        name,
        email,
        accept: Boolean(accepted)
      })

      if (!response) {
        throw ERROR.EMPTY_RESPONSE
      }

      setResponse(response)
      setHasError(false)
    } catch (error) {
      setResponse(EMPTY_POST_LEAD_RESPONSE)
      setHasError(true)
    } finally {
      setIsLoading(false)
    }

    return response
  }, [setIsLoading, setResponse, setHasError])

  return postLead
}

export default usePostLead
